module.exports = __webpack_public_path__ + "bb413262f6e349eaffcd1283ec6e8008.pdf";